import React, { useState } from 'react';
import ProductGrid from '../components/ProductGrid.jsx';
import SectionDivider from '../components/SectionDivider.jsx';
import Container from '../components/Container.jsx';

// Example product data (would be fetched from API in real app)
const allProducts = [
  { id: 1, image: '/images/baguette.jpg', title: 'Baguette Tradition', price: '1,20 €', tags: ['Pain', 'Tradition'] },
  { id: 2, image: '/images/croissant.jpg', title: 'Croissant Pur Beurre', price: '1,10 €', tags: ['Viennoiserie', 'Beurre'] },
  { id: 3, image: '/images/tartelette.jpg', title: 'Tartelette aux Fraises', price: '3,50 €', tags: ['Pâtisserie', 'Fruits'] },
  { id: 4, image: '/images/sandwich.jpg', title: 'Sandwich Jambon Fromage', price: '4,90 €', tags: ['Déjeuner', 'Sandwich'] },
  // ...more
];

const categories = [
  { label: 'Tous', value: '' },
  { label: 'Pain', value: 'Pain' },
  { label: 'Viennoiserie', value: 'Viennoiserie' },
  { label: 'Pâtisserie', value: 'Pâtisserie' },
  { label: 'Déjeuner', value: 'Déjeuner' },
];

export function ProductCategoryPage() {
  const [filter, setFilter] = useState('');
  const [search, setSearch] = useState('');

  const filtered = allProducts.filter(
    (p) =>
      (!filter || p.tags.includes(filter)) &&
      (p.title.toLowerCase().includes(search.toLowerCase()) || p.tags.some(t => t.toLowerCase().includes(search.toLowerCase())))
  );

  return (
    <Container className="py-12">
      <h1 className="text-3xl font-heading font-bold text-primary mb-6">Nos produits</h1>
      <div className="flex flex-wrap gap-3 mb-6">
        {categories.map((cat) => (
          <button
            key={cat.value}
            className={`px-4 py-2 rounded-lg border transition-colors font-medium ${filter === cat.value ? 'bg-accent text-white border-accent' : 'bg-surface text-primary border-border hover:bg-accent/10'}`}
            onClick={() => setFilter(cat.value)}
          >
            {cat.label}
          </button>
        ))}
        <input
          type="text"
          placeholder="Rechercher..."
          className="ml-auto px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      <ProductGrid products={filtered} columns={3} />
      <SectionDivider />
    </Container>
  );
}

export default ProductCategoryPage;
